export const QUOTE_PROGRESS_STEPS = [
	{id: 'destination', messageId: 'progress.quote.datesAndDestination', target: '#destination'},
	{id: 'insured', messageId: 'progress.quote.travelers', target: '#insured'},
	{id: 'medical', messageId: 'progress.quote.medical', target: '#medical'},
	{id: 'coverage', messageId: 'progress.quote.coverages', target: '#coverage'},
	{id: 'results', messageId: 'progress.quote.results'},
];

export const QUOTE_STEP_MESSAGE_IDS = QUOTE_PROGRESS_STEPS.map(step => step.messageId);

export const createProgressSteps = (definitions, currentStep, formatLabel) => definitions.map((step, index) => ({
	...step,
	label: formatLabel(step.messageId),
	disabled: index >= currentStep || !step.target,
}));

export const PURCHASE_STEP_MESSAGE_IDS = [
	'progress.purchase.completeDetails',
	'progress.purchase.payment',
	'progress.purchase.thankYou',
];